import { render, staticRenderFns } from "./preview-banner.vue?vue&type=template&id=f56d465a&"
import script from "./preview-banner.vue?vue&type=script&lang=ts&"
export * from "./preview-banner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports